@if (active()) {
  @if (templateRef) {
    <ng-container [ngTemplateOutlet]="templateRef" />
  } @else {
    <ng-content />
  }
}
